module.exports = __webpack_public_path__ + "media/images/affinity_logo_blue-1ac01851813b904dbf19123d77f2beb2.svg";